import { render, staticRenderFns } from "./WorkSpace.vue?vue&type=template&id=12a3232e&scoped=true"
import script from "./WorkSpace.vue?vue&type=script&lang=js"
export * from "./WorkSpace.vue?vue&type=script&lang=js"
import style0 from "./WorkSpace.vue?vue&type=style&index=0&id=12a3232e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a3232e",
  null
  
)

export default component.exports